import React from 'react'
import PropTypes from 'prop-types'
import { Factory } from '@lacele/utils'
import DynamicReducer from '../DynamicReducer'
import Context from '../DynamicReducerProvider/Context'
import DidMount from '../utils/DidMount'
import WillUnmount from '../utils/WillUnmount'

class ReducerHolder extends React.Component {

    constructor(props) {
        super(props)
        this.firstChildDidMount = this.firstChildDidMount.bind(this)
        this.lastChildWillUnmount = this.lastChildWillUnmount.bind(this)
    }

    firstChildDidMount() {
        const {
            storeTarget,
            dynamicReducer,
            reducer,
            globalReducer
        } = this.props
        if (reducer) {
            dynamicReducer.addTarget(storeTarget, reducer)
        }
        if (globalReducer) {
            dynamicReducer.addGlobal(globalReducer, storeTarget)
        }
    }

    lastChildWillUnmount() {
        const {
            storeTarget,
            dynamicReducer,
            keepState,
            reducer,
            globalReducer
        } = this.props
        if (reducer) {
            dynamicReducer.removeTarget(storeTarget, keepState)
        }
        if (globalReducer) {
            dynamicReducer.removeGlobal(storeTarget)
        }
    }

    renderChildren() {
        const {
            children
        } = this.props
        return children ? React.Children.only(children) : null
    }

    render() {
        const {
            render,
            keepState,
            reducer,
            globalReducer,
            ...restProps
        } = this.props
        return (
            <React.Fragment>
                <DidMount didMount={this.firstChildDidMount} />
                {
                    render
                        ? render(restProps)
                        : this.renderChildren()
                }
                <WillUnmount willUnmount={this.lastChildWillUnmount} />
            </React.Fragment>
        )
    }
}

ReducerHolder.propTypes = {
    storeTarget: PropTypes.string.isRequired,
    dynamicReducer: PropTypes.instanceOf(DynamicReducer).isRequired,
    reducer: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.instanceOf(Factory)
    ]),
    globalReducer: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.instanceOf(Factory)
    ]),
    keepState: PropTypes.bool
}

export default (props) => (
    <Context.Consumer>
        {(dynamicReducer) => <ReducerHolder dynamicReducer={dynamicReducer} {...props} />}
    </Context.Consumer>
)
